import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto } from '@/models/adapters/SubscriptionAdapter';

import {
  cancelSubscription,
  CancelSubscriptionActionType,
  subscriptionCanceled,
  subscriptionCancelFailed,
} from '../../actions/subscription/cancelSubscription';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* cancelSubscriptionSaga({ payload }: CancelSubscriptionActionType) {
  const { id, feature, placeUuid, cancel } = payload;
  const token = yield getAuthenticationToken();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.cancelSubscription, token, {
    id,
    cancel,
  });
  const timestamp = moment();
  const responsePayload = { timestamp, subscription: fromDto(response.subscription), placeUuid, feature };
  if (!response.error) {
    const responseAction = subscriptionCanceled(responsePayload);
    yield put(responseAction);
  } else {
    const responseAction = subscriptionCancelFailed({ timestamp, id });
    yield put(responseAction);
  }
}

export default function* watchCancelSubscriptionSaga() {
  yield takeEvery(cancelSubscription, cancelSubscriptionSaga);
}
